import { GraphQLQuery, GraphQLQueryVariables } from "../typing";

export const createQueryString = (query: GraphQLQuery, variables: GraphQLQueryVariables) => {
    return JSON.stringify({
      ...query,
      variables
    });
  };